import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import TagsFieldset from './TagsFieldset';
import {CardBody} from 'reactstrap';

const DescriptionsFieldset = ({ formErrors }) => (
  <CardBody>
    <div className="DescriptionsFieldset">
      <div className="row">
        <div className="col-12">
          <FormField
            label="Event Summary"
            error={formErrors.get('summary')}
            name="summary"
            component="textarea"
            type="text"
            className="form-control"
            placeholder="Enter a short summary of key event details, this will get displayed in lists of events across our network of publishers."
            maxLength={200}
            normalize={val => val.substr(0, 200)}
            required
            infoUrl="https://support.evvnt.com/hc/en-us/articles/216668038-Details-Creating-a-great-event-summary"
          />
        </div>
        <div className="col-12">
          <FormField
            label="Event Description"
            error={formErrors.get('description')}
            name="description"
            component="textarea"
            type="text"
            className="form-control"
            placeholder="Enter a more detailed description of your event, including what will be occurring, who should go and all other major details. This will be displayed on event full details pages across our network of publishers."
            maxLength={5000}
            normalize={val => val.substr(0, 5000)}
            required
            infoUrl="https://support.evvnt.com/hc/en-us/articles/360020922393-Details-Creating-an-awesome-description"
          />
        </div>
      </div>
    </div>
  </CardBody>
);

DescriptionsFieldset.propTypes = {
  formErrors: PropTypes.object,
};

export default DescriptionsFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/DescriptionsFieldset.jsx